module.exports = __webpack_public_path__ + "static/img/DDMC.963decc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/DDMC.png
// module id = gzZz
// module chunks = 34